import { Thresholds } from "./Thresholds";
export default Thresholds;
